import Link from 'components/Link'
import styles from './EventCTA.module.scss'

export default function EventCTA({ section }) {
  const { tagline, title, content, button } = section

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <img
          className={styles.decoration}
          alt=""
          role="presentation"
          loading="lazy"
          src="/img/happens.svg"
        />
        {tagline && <p className={styles.tagline}>{tagline}</p>}
        {title && <h3 className={styles.title}>{title}</h3>}

        {content && <p className={styles.content}>{content}</p>}

        {button && <Link className="btn btn--primary" link={button} />}
      </div>
    </section>
  )
}
